
import { mergeDateTime } from '@utils/Date';
import { parseEmbedUrl } from '@utils/Embed';
import { isAfter, isFuture } from 'date-fns';
import * as z from 'zod';

export const DEFAULT_OPTION = {
  title: '',
  description: '',
};

export const DEFAULT_QUESTION = {
  question: '',
  options: [{ ...DEFAULT_OPTION }, { ...DEFAULT_OPTION }],
};

export const DEFAULT_IMAGES = {
  options: [undefined, undefined],
};

export const QUESTION_SCHEMA = z.object({
  options: z
    .object({
      title: z.string().min(1, 'must not be empty').max(80),
      description: z
        .string()
        .max(80, 'Maximum length is 80 characters')
        .optional(),
      embed: z
        .string()
        .refine((v) => {
          if (v) return parseEmbedUrl(v);
          return true;
        }, 'Invalid media url')
        .optional(),
      price: z.string(),
      currency: z.string().optional(),
      image: z.any().optional(),
      removeImage: z.boolean().optional(),
    })
    .array()
    .min(1)
    .max(20),
});

export const CREATE_IDEA_SCHEMA = z
  .object({
    image: z.any().optional(),
    title: z.string().min(1, 'must not be empty').max(120),

    description: z
      .string()
      .max(1000, 'Maximum length is 1000 characters')
      .optional(),
    category:z.string(),
   
    video: z
      .string()
      .refine((v) => {
        if (v) return parseEmbedUrl(v);
        return true;
      }, 'Invalid media url')
      .optional(),
    themeID: z.string().optional(),
    pledgePeriod: z.object({
    
      focusedInput: z.enum(['startDate', 'endDate']).nullable(),
      startDate: z.date(),
      endDate: z.date(),
      startTime: z.date(),
      endTime: z.date(),
    }),
    pledges: QUESTION_SCHEMA,
    
  })
  ;

export type CreatePollData = z.infer<typeof CREATE_IDEA_SCHEMA>;
